<template lang="pug">
div
  div.container.mx-auto.text-acn-green
    .flex.items-center.flex-wrap.sm_flex-no-wrap.justify-around
      p(v-dompurify-html="globals.slogan").text-center.px-4.w-full.sm_w-auto.flex-shrink-0.sm_flex-shrink
      div.relative.text-center.flex-shrink-0.my-8.sm_order-first
        router-link( :to="{name:'quotes'}" tag='div').block.transform.duration-500.hover_scale-110 
          img(v-if='logoQuotesUrl' :src='logoQuotesUrl' alt='logo' v-in-viewport ).mx-auto.w-64.my-8
      div.relative.text-center.flex-shrink-0.my-8
        router-link( :to="{name:'videos'}" tag='div').block.transform.duration-500.hover_scale-110
          img(v-if='logoVidoesUrl' :src='logoVidoesUrl' alt='logo' v-in-viewport ).mx-auto.w-64.my-8

  .sticky.top-0.bg-acn-green-lighter.z-20
    nav#section-links.flex.w-full.justify-center.items-center.p-2.pt-4.text-acn-green.text-sm.sm_text-xl.font-black
      router-link(v-for='section of $store.getters.sections' :key='section.title' exact-active-class='underline text-acn-green-dark' :to="{name:'section', params:{sectionHandle:section.handle}}").mx-2 {{section.title}}
  transition(name="quick-fade" appear mode='out-in') 
    router-view().z-10
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Wrapper',
  computed: {
    ...mapState(['globals']),
    logoVidoesUrl() {
      if (
        this.$store.state.socials.logoVideos &&
        this.$store.state.socials.logoVideos.length
      ) {
        return this.$store.state.socials.logoVideos[0].url
      }
      return null
    },
    logoQuotesUrl() {
      if (
        this.$store.state.socials.logoQuotes &&
        this.$store.state.socials.logoQuotes.length
      ) {
        return this.$store.state.socials.logoQuotes[0].url
      }
      return null
    },
  },
  mounted() {
    document.body.className = 'bg-acn-green-lighter'
  },
}
</script>

<style lang="css" scoped>
.block {
  cursor: pointer;
  height: 125px;
  width: 125px;
}
</style>
